import { createStandaloneToast } from '@chakra-ui/react';

const { toast } = createStandaloneToast();

export const ToastChakra = (title, description, status, duration, position) => {
  const isDark = window.localStorage.getItem('chakra-ui-color-mode') === 'dark';

  toast({
    title,
    description,
    status,
    duration,
    isClosable: true,
    variant: isDark ? 'solid' : 'left-accent',
    position: position || 'bottom-right',
  });
};

